import { render } from "./TandartsDenBosch.vue?vue&type=template&id=e5f4742c&scoped=true"
import script from "./TandartsDenBosch.vue?vue&type=script&lang=js"
export * from "./TandartsDenBosch.vue?vue&type=script&lang=js"

import "./TandartsDenBosch.vue?vue&type=style&index=0&id=e5f4742c&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f4742c"]])

export default __exports__